import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { format } from "date-fns";
import { fullDateFullYearFormat, timeFormat } from "@common/helpers/date";
import { memo } from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { NestedTaskRow } from "../../types";

export const CompletedAtCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        NestedTaskRow,
        NestedTaskRow["lastDoneAt"]
    >) => {
        const task = row.original;

        if (task.isGroup || task.isNewPlaceholder) {
            return null;
        }

        return (
            <ViewTableCell>
                {task.lastDoneAt ? (
                    <Tooltip content={format(task.lastDoneAt, timeFormat)}>
                        <div>
                            {format(task.lastDoneAt, fullDateFullYearFormat)}
                        </div>
                    </Tooltip>
                ) : (
                    <div>-</div>
                )}
            </ViewTableCell>
        );
    },
);
